<section class="pt-3">
  <screen-support></screen-support>  
</section>


<section class="sfe-safe pt-5 sfe-welcome">
  <h1 class="sfe-welcome-head"> Model Assessment Results</h1>
 
    <p>The following are the prospective results of the business' assessment based on the answers provided.
      Each section has an overall score, then is broken down into a subsection to give more insight. Scores are supplemented with recommendations, catered to the business.
     The summary includes informational recommendations, resources, downloadable templates and materials, and/or organization or business refferals to help meet your goals.
    </p>
 
  </section>

  <nav aria-label="breadcrumb" class="pt-5 ">
    <ol class="breadcrumb">
      <li class="breadcrumb-item " aria-current="page">
        <div *ngIf="authService.isAdmin == false">
          <a routerLink="/entrep-dash">Dashboard</a>
        </div>
        <div *ngIf="authService.isAdmin == true">
          <a routerLink="/admin-dash">Dashboard</a>
        </div>
      </li>
      <li class="breadcrumb-item active" aria-current="page">Model Assessment</li>
    </ol>
  </nav> 

  <ng-template #pending>
    <div class="mat-spinner-container">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>
  
  <section  class="sfe-safe" *ngIf="show">
    <div id="element-to-export">
      <div id="zdex" *ngIf="!pendingData else pending" >
        <article class="pt-5 pb-2">
       
          
        </article>
        <article class="pt-5">
          <mat-tab-group >
            <mat-tab label="Overall">
              <div class="pt-5"></div>
              <div id="element-to-export">
                <div class="view-header">
                  <!--Assessment Name-->
                  <div class = row>
                    <div class="col-lg-6 col-md-6 col-sm-12 sfe-col-spacer">
                      <mat-card class="sfe-card">
                        <mat-card-title-group>
                            <mat-card-title>
                               Business Owner Details
                            </mat-card-title>
                            <mat-card-subtitle>
                               <!--something-->
                            </mat-card-subtitle>
                           <mat-icon class="icon-size">people</mat-icon>
                        </mat-card-title-group>
                        <mat-card-content>
                          <br/>
                          <div [ngClass]="{'show-less': showTxtDescription}">
                         
                             <ul class="list-group list-group-flush">
                              <li class="list-group-item"> {{data?.busiFirstName}} {{data?.busiLasttName}} </li>
                              <li class="list-group-item">{{data?.busiName}}</li>
                              <li class="list-group-item">{{data?.busiTelephone}} </li>
                              <li class="list-group-item">{{data?.busiEmail}}</li>
                              <li class="list-group-item"> {{data?.busiZipcode}} </li>
                              <li class="list-group-item"> {{data?.busiWebsite}}  </li>
                            </ul>
                           
                            </div>
                            <div class="pt-2"></div>
                          </mat-card-content>
                      </mat-card>
                  </div>
               
                     
                        <div class="col-lg-6 col-md-6 col-sm-12 sfe-col-spacer">
                          
                          <mat-card class="sfe-card">
                            <mat-card-title-group>
                                <mat-card-title>
                                    Action Items Added
                                </mat-card-title>
                                <mat-card-subtitle>
                                  {{data?.busiName}}'s' Action Plan
                                </mat-card-subtitle>
                               <mat-icon class="icon-size">track_changes</mat-icon>
                            </mat-card-title-group>
                            <mat-card-content>
                              <br/>
                              <div [ngClass]="{'show-less': showTxtDescription}">
                                <p> 
                                  The following Action Items have been added to your Action Plan based on your assessment results.  
                                  <a type="button"  color="primary" routerLink="/action-plan">View Plan
                                </a>    
                              </p>
                              <br/>
                                <ul>
                                  <li *ngFor="let action of assessmentPayload?.actionItemsModelArray">
                                     {{action}}
                                  </li>
                                </ul>
                                 
                               
                                </div>
                                <div class="pt-2"></div>
                              </mat-card-content>
                              <mat-divider inset></mat-divider>
                                <mat-card-actions>
                                    <button mat-button (click)="showTxt()">{{ showTxtDescription ? 'READ MORE': 'READ LESS' }}</button>
                                </mat-card-actions>
                          </mat-card>
                        </div>
                      </div>
                  </div>

                  <div class="pt-5"></div>
                  <!--Section Results-->
                  <div  class="section-results d-flex">
                    <div id="results-bg" class="row w-100 my-auto results-bg"> 
                      <div class="col-lg-3 col-md-3 col-sm-12">
                        <mat-card class="view-card"> 
                          <mat-title-group>
                            <div class="pt-3"></div>
                            <mat-card-title class="card-title-offer">{{assessmentPayload?.overallSustainibleScore?.finalOverallAverage*100 | number:'1.0-0'}}%</mat-card-title>
                            <mat-card-subtitle class="card-sub-title-offer pt-3">Overall Score</mat-card-subtitle>
                          </mat-title-group>
                            <mat-card-content class="card-content">
                              The overall business model score.  
                            </mat-card-content>
                          </mat-card>
                      </div>     
                      <div class="col-lg-3 col-md-3 col-sm-12">
                        <mat-card class="view-card"> 
                          <mat-title-group>
                            <div class="pt-3"></div>
                            <mat-card-title class="card-title-offer">{{assessmentPayload?.offerOverall?.finalOfferOverallAverage*100 | number:'1.0-0'}}%</mat-card-title>
                            <mat-card-subtitle class="card-sub-title-offer pt-3">Offer Competitiveness</mat-card-subtitle>
                          </mat-title-group>
                            <mat-card-content class="card-content">
                              Potential competitiveness of the {{data?.offerType?.name}} in the market.
                            </mat-card-content>
                          </mat-card>
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-12">
                        <mat-card class="view-card">
                          <mat-title-group>
                            <div class="pt-3"></div>
                            <mat-card-title class="card-title-prod">{{assessmentPayload?.pmfOverallScore?.finalPMFOverallAverage*100 | number:'1.0-0'}}%</mat-card-title>
                            <mat-card-subtitle class="card-sub-title-prod pt-3">Product Market Fit</mat-card-subtitle>
                          </mat-title-group>
                              
                          <mat-card-content class="card-content"> 
                            <p>
                              The degree to which the {{data?.offerType?.name}} satisfies a strong market demand. 
                            </p>
                          </mat-card-content>
                        </mat-card>
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-12">
                        <mat-card class="view-card">
                          <mat-title-group>
                            <div class="pt-3"></div>
                            <mat-card-title class="card-title-team">{{assessmentPayload?.teamOverall?.finalTeamOverallAverage*100 | number:'1.0-0'}}%</mat-card-title>
                            <mat-card-subtitle class="card-sub-title-team pt-3">Team Dynamic</mat-card-subtitle>
                          </mat-title-group>
                          
                          <mat-card-content class="card-content">
                            <p>
                              The ability for the team to execute on the vision.
                            </p>
                          </mat-card-content>
                        </mat-card>
                      </div>
                      </div>
                    </div>
                </div>
              
              
             
      
              <div class="pt-5">
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12">
                    <mat-card class="purple reslt-cards">
                        <mat-card-content class="row">
                          <div class="col-2 d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center ">
                            <mat-card-title>Offer</mat-card-title>
                          </div>
                          <div class="col-10">
                              <p>The characteristics of a {{data?.offerType?.name}} can determine its market competitiveness. 
                                <li> Offer Importance helps determine to what degree the {{data?.offerType?.name}} is a need versus a want.</li> 
                                <li>Offer Innovation helps determine market position, potential competitiveness and market share.</li>  
                                <li>Offer Industry provides insight into the industry in which the {{data?.offerType?.name}} exists.</li>
                            </p>
                          </div>
                    
                        </mat-card-content>
                      </mat-card>
                      <div class="pb-3"></div>
                      <mat-card class="black reslt-cards">
                        <mat-card-content class="row">
                          <div class="col-2 d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center ">
                            <mat-card-title>Product-Market Fit</mat-card-title>
                          </div>
                          <div class="col-10">
                              <p>Product-Market Fit is the degree to which a {{data?.offerType?.name}} satisfies a strong market demand. 
                                It is important to consider if a customer will purchase from, and be satisfied with, your 
                                {{data?.offerType?.name}} enough for your business to sustain.
                            </p>
                          </div>
                    
                        </mat-card-content>
                      </mat-card>
                      <div class="pb-3"></div>
                      <mat-card class="blue-light reslt-cards">
                        <mat-card-content class="row">
                          <div class="col-2 d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center ">
                            <mat-card-title>Team Dynamic</mat-card-title>
                          </div>
                          <div class="col-10">
                              <p>When investors choose to invest, many invest in the team versus the idea because people build
                                businesses. Ideas may change throughout a business' lifetime, but it is likely that a well-established team will retain
                                the ability to execute.  If the team is not able to get along, be productive and/or execute on the idea, the venture may fail.
                            </p>
                          </div>
                    
                        </mat-card-content>
                      </mat-card>
                      <div class="pb-3"></div>
                    <!--  <mat-card class="green reslt-cards">
                        <mat-card-content class="row">
                          <div class="col-2 d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center ">
                            <mat-card-title>Revenue</mat-card-title>
                          </div>
                          <div class="col-10">
                            <p> Sustainable cash flows are cricital to small business survival. Use the Revenue Calculator to project your numbers. 
                          </p>
                          </div>
                    
                        </mat-card-content>
                      </mat-card>-->
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <mat-card>
                      <mat-card-title>How to Use</mat-card-title>
                      <mat-card-subtitle>Business Assessment Engine</mat-card-subtitle>
                      <mat-card-content>
                        Please remember, scores, results and recommendations are informational. Scores compare to an ideal sustainable business model.
                        <li>Excellent: 85% or more</li>
                        <li>Good: 84%-69%</li>
                        <li>Average: 68%-53%</li>
                        <li>Below Average: 52%-37%</li>
                        <li>Poor: 36% or less</li>
                        <p>
                          These results are not to discourage business ventures, but rather inform business models and possibilities for risks or improvements.
                          These results are not meant to replace the human touch and we encourage you to seek counsel where needed. 
                           Please provide feedback upon reviewing your results to help improve your user experience. 
                        </p>
                      </mat-card-content>
                    </mat-card>
                    <div class="pb-3"></div>
                   <!-- <mat-card>
                      <mat-card-title> Your Assessments</mat-card-title>
                      <mat-card-subtitle>All Assesments Taken</mat-card-subtitle>
                      <mat-card-content>
                        <mat-list >
                          <mat-list-item>
                            <span class="teal">{{data?.busiName}}</span>
                          </mat-list-item>
                          <mat-divider></mat-divider>
                        </mat-list>
                        <div class="pt-3"></div>
                        <button class="btn-green" mat-raised-button routerLink="/view-assessments">View Assessment</button>
                      </mat-card-content>
                    </mat-card>-->
                   
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab  label="Offer">
              <div class="pt-5"></div>
               <div class="row">
                 <div class="col-4"> 
                    <mat-card class="">
                      <div class="pt-3"></div>
                      <mat-card-header class="d-flex justify-content-between">
                        <mat-card-title class="scoreText">
                         {{assessmentPayload?.offerOverall?.finalOfferOverallAverage*100 | number:'1.0-0'}}%
                        </mat-card-title>
                        <mat-card-subtitle class="pt-3">
                          <button mat-button color="primary"></button>
                        </mat-card-subtitle>
                        <div  *ngIf="finalOfferOverallAverage < 0.53">
                          <mat-icon class="red">thumb_down_alt</mat-icon>
                        </div>
                        <div  *ngIf="finalOfferOverallAverage > 0.53">
                          <mat-icon class="teal">thumb_up_alt</mat-icon>
                        </div>
                      </mat-card-header>
                      <mat-card-content>
                        <div [ngClass]="{'lmtTxtHeight': isReadMore}">
                          <h4>Overall Offer Score</h4>
                           <p>
                            These results are not to discourage business ventures, but rather inform business models and possibilities for risks or improvements. 
                            <li>Please remember, scores, results and recommendations are informational.</li>
                            <li>These results are not meant to replace the human touch and we encourage you to seek counsel where needed. </li>
                            <li> Please provide feedback upon reviewing your results to help improve your user experience. </li>
                          </p>
                        </div>
                        <div class="pt-2"></div>
                       <button mat-flat-button color="primary" (click)="showTxt()">
                          {{isReadMore ? 'Read More' : 'Read Less'}}
                        </button> 
                      </mat-card-content>
                    </mat-card>  
              
                 </div>
      
                 <div class="col-8">
                  <h2>Offer Competitiveness Summary</h2>
                  <p>The characteristics of a {{data?.offerType?.name}} can determine its market competitiveness. 
                    <li>'How Big is the Problem You're Solving?' helps determine to what degree the {{data?.offerType?.name}} is a need versus a want.</li> 
                    <li>'How is Your {{data?.offerType?.name}} Different?' helps determine market position, potential competitiveness and market share.</li>  
                    <li>'What is the Condition of Your Industry?' provides insight into the industry in which the {{data?.offerType?.name}} exists.</li>
                </p>
                 <!--<h2>Goal Status </h2>
                 <div class="progress">
                  <div class="progress-bar" role="progressbar" style="width: 25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div>
                </div> -->
       
                </div>
               </div>
               <!--end row-->
               <!--row-->
               <div class="pt-5"></div>
               <div class="row">
                 <div class="col-lg-4 col-md-4 col-sm-12">
                      <mat-card>
                        <mat-card-header>
                            <mat-card-title> Sub Section Scores</mat-card-title>
                              <mat-card-subtitle>All Assesments Taken</mat-card-subtitle>
                        </mat-card-header>
                            <mat-card-content>
                              <ul class="list-group list-group-flush">
                                <li class="list-group-item d-flex justify-content-between align-items-center purple-txt">
                                  Problem Size
                                  <h2 ><span class="badge">{{assessmentPayload?.offerImportanceScore?.status}}</span></h2>
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center blue-txt">
                                  {{offerType?.name}} Differentiation
                                 <h2 ><span class="badge">{{assessmentPayload?.offerInnovationScore?.status}}</span></h2>
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center teal">
                                 Industry Condition
                                 <h2 ><span class="badge">{{assessmentPayload?.offerIndustryScore?.status}}</span></h2>
                                </li>
                       
                              </ul>
                         
                                <div class="pt-3"></div>
                                </mat-card-content>
                      </mat-card>
                 </div>
              
                <div class="col-lg-8 col-md-8 col-sm-12">
                    <mat-card>
                      <div class="pt-3"></div>
                      <mat-card-header class="d-flex justify-content-between">
                        <mat-card-title class="scoreText">{{assessmentPayload?.offerImportanceScore?.finalOfferImportancePercentage*100 | number:'1.0-0'}}%</mat-card-title>
                       <mat-card-subtitle class="pt-3">{{assessmentPayload?.offerImportanceScore?.status}}</mat-card-subtitle>
                     <div align="end">
                      <div *ngIf="finalOfferImportancePercentage < 0.53">
                        <mat-icon  class="red">thumb_down_alt</mat-icon>
                      </div>
                      <div *ngIf="finalOfferImportancePercentage > 0.53">
                        <mat-icon class="teal">thumb_up_alt</mat-icon>
                      </div>
                     </div>
                      </mat-card-header>
                    
                      <mat-card-content>
                        <h2 class="title">How Big is the Problem You're Solving?</h2>
                        <div><!--Offer Urgency-->
                          <div *ngIf="data?.marketTargetLocation?.value >= 2; else marketTargetLocationElse">
                            <p>Because {{data?.busiName}} addresses a problem that reaches a large {{data?.marketTargetLocation?.name}} market, 
                              a lot of people could experience the problem that its solving, potentially signaling demand. <b>Hone in on your 
                              specific market size through market research and highlight it as a strength in your business plan.</b> 
                              MaRS features a forumla to help calculate market size here: <a href="https://learn.marsdd.com/article/how-to-estimate-market-size-business-and-marketing-planning-for-startups/"
                              target="_blank"  rel="noopener noreferrer">How to estimate market size: Business and marketing planning for startups</a>
                            </p>
                          </div>
                          <ng-template #marketTargetLocationElse>
                            <p>{{data?.busiName}} addresses a problem that reaches a {{data?.marketTargetLocation?.name}} market. 
                              <b>Think of ways to make yourself known in the community.</b> This can be achieved by on-the-ground advertising, 
                              contributing to the community through social missions or creating a space to bring the community together. Get some ideas from this Forbes article 
                              <a href="https://www.forbes.com/sites/forbescoachescouncil/2020/02/26/15-unique-ways-a-small-business-can-become-a-staple-in-its-community/?sh=45c1d3dd85c0"
                              target="_blank"  rel="noopener noreferrer">15 Unique Ways A Small Business Can Become A Staple In Its Community</a>.
                            </p>
                          </ng-template>
                        </div>
                        <div><!--Offer Urgency-->
                          <div *ngIf="data?.offerUrgency?.value >= 3; else offerUrgencyElse">
                            <p>It seems customers would purchase the {{data?.offerType?.name}} with a '{{data?.offerUrgency?.name}}'. This
                              shows a good level of need, demand and/or market fit.
                            </p>
                          </div>
                          <ng-template #offerUrgencyElse>
                            <p>It seems customers would purchase with a ‘{{data?.offerUrgency?.name}}’. 
                              This can show a low level of need, demand or market fit. If applicable, <b>adjust ‘{{data?.offerType?.name}}’ features 
                              until it is prioritized enough for someone to write it in their monthly budget; 
                              or target a different customer that will priortize your ‘{{data?.offerType?.name}}’ higher.</b> 
                              {{retrieveRecommandationText('offerUrgency')}}
                            </p>
                          </ng-template>
                        </div>
      
                        <div><!--ngTemplate-->
                          <div *ngIf="data?.offerFrequency?.value >= 3; else offerFrequencyElse">
                            <p>
                              The frequency in which a customer may use the {{data?.offerType?.name}} was selected as
                              ‘{{data?.offerFrequency?.name}}’. So, make sure to <b>prioritize the 
                              durability of the product and/or create a plan to provide great customer service.</b> Check out <a href="https://www.entrepreneur.com/article/287822"
                              target="_blank" rel="noopener noreferrer"> The 4 Essentials of a Customer Service Plan </a> or
                              <a href="http://sustainible.io/resources/customer-service/"
                              target="_blank" rel="noopener noreferrer">our Customer Service video module compilation.</a>
                            </p>
                          </div>
                          <ng-template #offerFrequencyElse>
                            <p>The frequency in which the customer may use the {{data?.offerType?.name}} was selected as
                              ‘{{data?.offerFrequency?.name}}’. If frequency can't be increased, <b>come up with ideas, 
                              or add-on features, to increase the amount of times a customer purchases from you</b> , such as subscription models or retainers.
                              Otherwise, think of ways to increase frequency of purchase. {{retrieveRecommandationText('offerFrequency')}} 
                            </p>
                          </ng-template>
                        </div>
                      </mat-card-content>
                     <!-- <mat-card-footer class="p-2">
                        <mat-form-field appearance="fill">
                          <mat-label>Set Goal</mat-label>
                          <mat-select [(ngModel)]="probSolvStat" name="statResponse">
                            <mat-option *ngFor="let statResponse of statResp" [value]="statResponse?.value">
                              {{statResponse?.viewValue}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      <p> Selected Answer: {{probSolvStat}} </p>
                      </mat-card-footer> -->
                    </mat-card>
                </div>  
                     
              </div>
              <div class="pt-5"></div>
              <!--end row-->
              <div class="row">
                <!--How product or service different-->
                 <div class="col">
                  <mat-card>
                    <div class="pt-3"></div>
                    <mat-card-header class="d-flex justify-content-between">
                      <mat-card-title class="scoreText">{{assessmentPayload?.offerInnovationScore?.finalOfferInnovationPercentage*100 | number:'1.0-0'}}%</mat-card-title>
                      <mat-card-subtitle class="pt-3">{{assessmentPayload?.offerInnovationScore?.status}}</mat-card-subtitle>
                   <div align="end">
                    <div *ngIf="finalOfferInnovationPercentage < 0.53">
                      <mat-icon  class="red">thumb_down_alt</mat-icon>
                    </div>
                    <div *ngIf="finalOfferInnovationPercentage > 0.53">
                      <mat-icon class="teal">thumb_up_alt</mat-icon>
                    </div>
                   </div>
                    </mat-card-header>
                  
                    <mat-card-content>
                      <h2 class="title">How is Your {{data?.offerType?.name}} Different?</h2>
                      <div>
                        <p> Your differentiators: {{assessmentPayload?.offerDifferentiationNameArray?.offerDifferentiationNameArray}}.</p>
                        <p> The above {{assessmentPayload?.offerDiffCheckBoxCount}} differentiators were selected out of 6 possible options:
                          Quality, Design, Service and interactions, Features and functionalities, Customization, Pricing.
                        </p>
                        <div *ngIf="assessmentPayload?.offerDiffCheckBoxCount >= 3; else offerDifferentiatorsSelectionsElse">
                          <p> Great {{data?.offerType?.name}} differentiation! <b>Hone in on these elements in your marketing.</b>
                           Ex. As a social media strategy, you can highlight each of these features in a post. 
                           To get started with marketing plans and enhance execution, HubSpot features some tools <a href="https://blog.hubspot.com/marketing/social-media-calendar-tools"
                           target="_blank" rel="noopener noreferrer">here.</a></p>
                        </div>
                        <ng-template #offerDifferentiatorsSelectionsElse>
                          <p>When {{data?.offerType?.name}}s aren't much different from others, competition can be heavy and retaining
                            customers can be hard. <b>Try to differentiate your {{data?.offerType?.name}} in more areas.</b> Here is an
                            article, <a href="https://www.departmentofproduct.com/blog/how-to-differentiate-your-product/"
                              target="_blank" rel="noopener noreferrer">How to Differentiate Your Product</a>, by the Department of Product may help spark
                            some ideas.</p>
                        </ng-template>
                      </div>
      
                      <div>
                        <div *ngIf="data?.offerInnovation?.value  >= 3; else offerInnovationElse">
                          <p>
                            How innovative, unconventional, or unusual your business is, compared to your competitors', was rated as
                            ‘{{data?.offerInnovation?.name}}’. This means you could be considered a leader in your market, have a 
                            competitive advantage and/or stand out to customers. <b>Hone in on innovation in your marketing message 
                            and/or with lenders/investors</b>. You could also qualify for startup grants or accelerators that focus on innovation. 
                          </p>
                        </div>
                        <ng-template #offerInnovationElse>
                          <p>
                            How innovative, unconventional, or unusual your business is, compared to your competitors, was mentioned as it
                            ‘{{data?.offerInnovation?.name}}’ Sometimes this can't be changed, and that's okay. 
                            But if there is a way to position your business as an innovator or leader, hone in on it. {{retrieveRecommandationText('offerInnovation')}}</p>
                        </ng-template>
                      </div>
      
          <div>
            <div *ngIf="assessmentPayload?.offerImproveLifeCheckBoxCount > 0; else offerImproveLifeElse">
              <p>
                {{data?.busiName}} has potential to improve customer life in {{assessmentPayload?.offerImproveLifeCheckBoxCount}} area(s):
                {{assessmentPayload?.offerImproveLifeNameArray}}.
                This can signal high demand and business survival. If {{data?.busiName}} relates to a social mission, 
              <b> search 'Grants in the {{data?.offerIndustry?.name}} industry'. If you're not a non-profit, you can look into fiscal sponsorship.</b> </p> 
            </div>
            <ng-template #offerImproveLifeElse>
              <p>{{data?.busiName}} has potential to improve customer life in {{assessmentPayload?.offerImproveLifeCheckBoxCount}} area(s):
                {{assessmentPayload?.offerImproveLifeNameArray}}.
                {{data?.offerType?.name}}s that have the ability to improve a customer’s life can often signal 
                innovation or entice people to buy. <b>Even if your product or service isn't directly 
                related to improving a customer's life, determine an indirect benefit </b>and hone in on that in your marketing message, 
                or think of incorporating a social mission. {{retrieveRecommandationText('offerImproveLifeEssentiality')}}
            </p>
            </ng-template>
          </div>
                    </mat-card-content>
                   <!-- <mat-card-footer class="p-2">
                      <mat-form-field appearance="fill">
                        <mat-label>Set Goal</mat-label>
                        <mat-select [(ngModel)]="offDifferentiationStat" name="offDiffStat">
                          <mat-option *ngFor="let offDiffStat of statResp" [value]="offDiffStat?.value">
                            {{offDiffStat?.viewValue}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                     <p> Selected Answer: {{offDifferentiationStat}} </p>
                    </mat-card-footer>-->
                  </mat-card>
                 </div>
            
                 <div class="col">
                  <mat-card>
                    <div class="pt-3"></div>
                    <mat-card-header class="d-flex justify-content-between">
                      <mat-card-title class="scoreText">{{assessmentPayload?.offerIndustryScore?.finalOfferIndustryPercentage*100 | number:'1.0-0'}}%</mat-card-title>
                      <mat-card-subtitle class="pt-3">{{assessmentPayload?.offerIndustryScore?.status}}</mat-card-subtitle>
                   <div align="end">
                    <div *ngIf="finalOfferIndustryPercentage < 0.53">
                      <mat-icon  class="red">thumb_down_alt</mat-icon>
                    </div>
                    <div *ngIf="finalOfferIndustryPercentage > 0.53">
                      <mat-icon class="teal">thumb_up_alt</mat-icon>
                    </div>
                   </div>
                    </mat-card-header>
                  
                    <mat-card-content>
                      <h2 class="title">What is the Condition of Your Industry?</h2>
                      <div>
                        <div *ngIf="data?.pmfOverproduction?.value < 3; else pmfOverproductionElse">
                          <p>
                            The industry may be saturated. Saturated markets have 
                            heavy competition, making it harder to retain or get customers. <b>To stand out to customers, 
                            differentiate your {{data?.offerType?.name}} more.</b>
                          </p>
                        </div>
                        <ng-template #pmfOverproductionElse>
                          <p>
                            Your market unsaturation may allow {{data?.busiName}} a better chance of capturing the market. 
                            So, <b>develop a strategy to capture your market.</b> <a href="https://blog.hubspot.com/marketing/social-media-calendar-tools"
                            target="_blank" rel="noopener noreferrer"> How to Capture Market Share Through the Understanding of Consumer Needs</a> provides a starting point list. 
                          </p>
                        </ng-template>
                      </div>
                      <div>
                        <div *ngIf="assessmentPayload?.offerIndustryGrowthProjection2Yr?.industryGrowthScore2 >= 3; else offerIndustryGrowthElse">
                          <p> 
                            <li>The 2 Year Expected Revenue Growth Rate of the {{data?.offerIndustry?.name}} industry is projected to be
                            {{assessmentPayload?.industrycagrInfo.RevenueExpectGrowth2Yr*100 | number:'1.0-0'}}%. </li>
                            <li>The 5 Year Revenue Compound Annual Growth Rate is projected to be {{assessmentPayload?.industrycagrInfo.RevenueCAGR5Yr*100 | number:'1.0-0'}}%. </li>
                            <li>The 5 Year Net Income (Profit) Compound Annual Growth Rate is projected to be {{assessmentPayload?.industrycagrInfo.NetIncomeCAGR5Yr*100 | number:'1.0-0'}}%. </li> 
                            Industries that are experiencing equilibrium states or growth states can signal 
                            stable or increasing business opportunities.
                          </p>
                        </div>
                        <ng-template #offerIndustryGrowthElse>
                          <p>
                            <li>The 2 Year Expected Revenue Growth Rate of the {{offerIndustry?.name}} industry is projected to be
                            {{assessmentPayload?.industrycagrInfo.RevenueExpectGrowth2Yr*100 | number:'1.0-0'}}%. </li>
                            <li>The 5 Year Revenue Compound Annual Growth Rate is projected to be {{assessmentPayload?.industrycagrInfo.RevenueCAGR5Yr*100 | number:'1.0-0'}}%. </li>
                            <li>The 5 Year Net Income (Profit) Compound Annual Growth Rate is projected to be {{assessmentPayload?.industrycagrInfo.NetIncomeCAGR5Yr*100 | number:'1.0-0'}}%. </li>
                            Industries that are experiencing a decline in growth can signal a declining business opportunity. <b>If you chose not to pivot markets, 
                            try to identify what is causing the market to decline and plan around it. </b>
                            </p>
                        </ng-template>
                      </div>
                      <div>
                        <div *ngIf="data?.offerSupplierPower?.value > 3; else offerSupplierPowerElse">
                          <p> {{data?.busiName}}'s suppliers are {{assessmentPayload?.offerSupplierNameArray}}. {{data?.busiName}}'s rated it 
                            ‘{{data?.offerSupplierPower?.name}}’ to switch suppliers if needed,
                            which can be a good sign. The power that suppliers have over a business 
                            can affect business progress and profit potential. Keep this in mind when looking for additional suppliers.
                          </p>
                        </div>
                        <ng-template #offerSupplierPowerElse>
                          <p>{{data?.busiName}}'s suppliers are {{assessmentPayload?.offerSupplierNameArray}}.  {{data?.busiName}}'s rated it 
                     ‘{{data?.offerSupplierPower?.name}}’ to switch suppliers if needed. The power that suppliers have over a business 
                            can affect business progress and profit potential. So, <b>try to  diversify suppliers 
                            or expand your supply options</b>. {{retrieveRecommandationText('offerSupplierPower')}}
                          </p>
                        </ng-template>
                      </div>
                      <div>
                        <div *ngIf="data?.offerBuyerPower?.value  > 2; else offerBuyerPowerElse">
                          <p>You mentioned ‘{{data?.offerBuyerPower?.name}}’. 
                            The power that your customers have over you can reduce your profit if pressured 
                             to reduce prices or change practices. It's helpful that the buyer’s bargaining 
                             power is low but still <b> prioritize good customer experiences. Sign up with <a href="https://www.google.com/business/"
                              target="_blank" rel="noopener noreferrer">  Google My Business </a>, or incorporate a 'Reviews' page on your website to showcase your customer experiences. </b>
                            </p>
                            </div>
                        <ng-template #offerBuyerPowerElse>
                          <p>You mentioned ‘{{data?.offerBuyerPower?.name}}’. 
                            The power that your customers have over you can reduce your profit if pressured 
                            to reduce prices or change practices. Determine how to navigate
                             buyer power through strategic planning.
                            The <a href="https://strategicmanagementinsight.com/tools/vrio.html" target="_blank" rel="noopener noreferrer"> VRIO
                              Framework</a> may serve useful.</p> {{retrieveRecommandationText('offerBuyerPower')}}
                        </ng-template>
                      </div>
      
      
                    </mat-card-content>
                   <!-- <mat-card-footer class="p-2">
                      <mat-form-field appearance="fill">
                        <mat-label>Set Goal</mat-label>
                        <mat-select [(ngModel)]="industryCondStat" name="industryCond">
                          <mat-option *ngFor="let industryCond of statResp" [value]="industryCond?.value">
                            {{industryCond.viewValue}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                  <p> Selected Answer: {{industryCondStat}} </p>
                    </mat-card-footer>-->
                  </mat-card>
                </div>
                 
              </div>
              <!--end row-->
            </mat-tab>
            <!--end offer tab-->
            <!--Start Product Tab-->
            <mat-tab  label="Product Market Fit">
              <div class="pt-5"></div>
               <div class="row">
                 <div class="col-4"> 
                    <mat-card class="">
                      <div class="pt-3"></div>
                      <mat-card-header class="d-flex justify-content-between">
                        <mat-card-title class="scoreText">
                         {{assessmentPayload?.pmfOverallScore?.finalPMFOverallAverage*100 | number:'1.0-0'}}%
                        </mat-card-title>
                        <mat-card-subtitle class="pt-3">
                          <button mat-button color="primary"></button>
                        </mat-card-subtitle>
                        <div  *ngIf="finalPMFOverallAverage < 0.53">
                          <mat-icon class="red">thumb_down_alt</mat-icon>
                        </div>
                        <div  *ngIf="finalPMFOverallAverage > 0.53">
                          <mat-icon class="teal">thumb_up_alt</mat-icon>
                        </div>
                      </mat-card-header>
                      <mat-card-content>
                        <div [ngClass]="{'lmtTxtHeight': isReadMore}">
                          <h4>Product-Market Fit Score Summary</h4>
                           <p>Product-Market Fit is the degree to which a {{data?.offerType?.name}} satisfies a strong market demand.
                            When considering if a customer will purchase from, and be satisfied with, your {{data?.offerType?.name}} enough for your business
                            to sustain, it is important to consider an array of factors.
                            Some can be as large as market location to as small as point-of-sale types. <b>The best way to determine
                            Product Market Fit is to ask customers, perform surveys, test your {{data?.offerType?.name}}, and continue to
                            iterate and innovate.</b>
                            This section can help give you a starting point. It can help refine your customer base by providing
                            insights to create a SWOT and develop your market strategy.</p>
                        </div>
                        <div class="pt-2"></div>
                        <button mat-flat-button color="primary" (click)="showTxt()">
                          {{isReadMore ? 'Read More' : 'Read Less'}}
                        </button>
                      </mat-card-content>
                    </mat-card>  
              
                 </div>
      
                 <div class="col-8">
                <!-- <h2>Goal Status </h2>
                 <div class="progress">
                  <div class="progress-bar" role="progressbar" style="width: 25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div>
                </div>-->
                <h2>Customer Persona</h2>
                <p>A customer persona allows teams to better understand their customer as a clustered group and recognize
                  key traits within them. Clustered and targeted grouping can allow teams to fine tune their {{offerType?.name}}, craft their customer
                  experience and help develop sales funnels and marketing efforts.
                  This can help to build an in-depth detailed picture of the (hypothetical) customer, and surface
                  emotive information such as why the customer values the product, what kind of communication they prefer, etc.</p>
                <div>
                  <ng-container *ngIf="data?.marketTargetB2BC?.name === 'Business to Consumer'; else B2BPersona">
                    <!--GET THIS-->    <h2 class="title">Customer Persona</h2>
                        <ul>
                          <li>Age: {{data?.marketTargetAge?.name}}</li>
                          <li>Ethnicity: {{data?.marketTargetEthnicity?.name}}</li>
                          <li>Gender: {{data?.marketTargetGender?.name}}</li>
                          <li>Occupation: {{data?.marketTargetOccupation?.name}}</li>
                          <li>Location: {{data?.marketTargetLocation?.name}}</li>
                        </ul>
                      </ng-container>
                      <ng-template #B2BPersona>
                        <h2 class="title">Business Persona</h2>
                        <ul>
                          <li>Target Industry: {{data?.marketTargetB2BIndustry?.name}} </li>
                          <li>Target Occupation: {{data?.marketTargetB2BOccupation?.name}}</li>
                          <li>Decision Maker: {{data?.marketTargetB2BDecisionMaker?.name}}</li>
                          <li>Market Reach: {{data?.marketTargetLocation?.name}}</li>
                        </ul>
                        <div *ngIf="data?.marketTargetB2BDecisionMaker?.name  === No">
                          <p>Your target customer is not a decision-maker in the organization. 
                            This can create a longer sales process for you. <b>Shorten the sales cycle 
                            by including decision-makers in your sales outreach. </b>
                          </p>
                        </div>
                      </ng-template>
                </div>
       
                </div>
               </div>
               <!--end row-->
               <!--row-->
               <div class="pt-5"></div>
               <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12">
                  <mat-card>
                    <mat-card-header>
                        <mat-card-title> Sub Section Scores</mat-card-title>
                    </mat-card-header>
                        <mat-card-content>
                          <ul class="list-group list-group-flush">
                            <li class="list-group-item d-flex justify-content-between align-items-center purple-txt">
                              Satisfying Consumer Demand
                              <h2 ><span class="badge">{{assessmentPayload?.pmfConsumerDemandScore?.status}}</span></h2>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center blue-txt">
                             Market Saturation
                             <h2 ><span class="badge">{{assessmentPayload?.pmfOverproductionScore?.status}}</span></h2>
                            </li>             
                          </ul>
                     
                            <div class="pt-3"></div>
                            </mat-card-content>
                  </mat-card>
                  </div>
                  <div class="col-lg-8 col-md-8 col-sm-12">
                    <mat-card>
                      <div class="pt-3"></div>              
                      <mat-card-content>
                        <h2 class="title">Strengths, Weaknesses, Opportunities and Threats (SWOT)</h2>
                        <div><!--SWOT Analysis-->
                                   <!--ng template-->
                                   <div>
                                    <b>Satisfying Consumer Demand</b>
                                    <p>
                                      Consumers are dissatisfied in the areas of: {{assessmentPayload?.pmfCompetitorDissatisfactionNameArray?.pmfCompetitorDissatisfactionNameArray}}.
                                     <br><span class="swotText">Strength: </span>{{data?.busiName}} is differentiated in the areas of: {{assessmentPayload?.offerDifferentiationNameArray?.offerDifferentiationNameArray}}.
                                     
                                    </p>
                                    <ng-container *ngIf="assessmentPayload?.pmfSolveNeedScore > 3; else pmfSolveNeedScoreSecond">
                                      <p>
                                        <span class="swotText">Strength: </span> {{data?.busiName}}'s solution satisfies existing consumer dissatisfaction at a high rate, signaling 
                                        potential demand.
                                      </p>
                                    </ng-container>
                                    <ng-template #pmfSolveNeedScoreSecond>
                                      <ng-container *ngIf="assessmentPayload?.pmfSolveNeedScore < 3">
                                        <p>
                                          <span class="swotText">Weakness: </span>Competitor's customers are dissatisfied in certain areas, 
                                          but {{data?.busiName}} doesn't address the majority of those areas. This could signal similar customer dissatisfaction in these areas. 
                                           <b>{{data?.busiName}} should consider addressing any remaining areas that consumers are dissatisfied, but  it
                                             currently doesn't differentiate itself in. </b>
                                          </p>
                                      </ng-container>
                                    </ng-template>
                                     <p>
                                      <span class="swotText">Threat: </span>If {{data?.busiName}}'s {{data?.offerType?.name}} isn’t differentiated by much or doesn’t continue to innovate - and competitors see the {{data?.offerType?.name}} 
                                        is attracting more customers - some may copy {{data?.busiName}} and competition can increase. <b>Continue to innovate to overcome this threat</b>.
                                      </p>
                                    <ng-container *ngIf="pmfCompetitorDissatisfactionExists == false">
                                      <p>
                                        <span class="swotText">Threat: </span> {{data?.busiName}}'s competitors are leaving consumers satisfied. This could increase market 
                                        barriers to entry if consumers are loyal to competitor brands.
                                      </p>
                                      <p>
                                        <span class="swotText">Opportunity: </span> There can be an opportunity to differentiate {{data?.busiName}} further or diversify 
                                        the target market demographics (target age, gender, location, etc.).
                                      </p>
                                    </ng-container>
                                  </div>
                    <div>
                      <!--ng template-->
                      <b>Market Saturation</b>
                      
                      <ng-container *ngIf="2 >= assessmentPayload?.offerIndustryGrowthProjection2Yr?.industryGrowthScore2; else pmfOverproductionfirst">
                        <p>
                          <span class="swotText">Threat: </span> The number of competitors targeting the same customer was rated as
                          ‘{{data?.pmfOverproduction?.name}}’, but the industry may be declining. Possibly meaning, competitors have left the industry due to the market condition. 
                        </p>
                       </ng-container>
                       <ng-template #pmfOverproductionfirst>
                        <p>
                            The number of competitors targeting the same customer was rated as
                            ‘{{data?.pmfOverproduction?.name}}'.
                       </p>
                    </ng-template>
                      <ng-container *ngIf="2 >= data?.pmfOverproduction?.value; else pmfOverproductionsecond">
                       <p>
                        <span class="swotText">Weakness: </span> There are many competitors in the market who are already fulfilling demand,
                        which signals potential market saturation.
                       </p>
                       <p>
                        <span class="swotText">Threat: </span> Higher Buyer Power: The market is saturated so consumer’s ability to 
                        influence business operations can rise. Prepare for this through stratgic planning.  
                       </p>
                      </ng-container>
                      <ng-template #pmfOverproductionsecond>
                          <p>
                            <span class="swotText">Opportunity: </span> Market unsaturation may mean that there are not enough competitors to fulfill 
                            the existing level of demand, which allows room for {{data?.busiName}} to capture the market easier than not.
                         </p>
                      </ng-template>
                      <ng-container *ngIf="'Product' == data?.offerType?.name; else mvpService">
                      <p>
                       The best way to determine Product Market Fit, as mentioned above, is to ask your customer directly through primary market research.
                       Below are some resources that you can access to create and execute Product Market Fit research:
                        <li> Step 1: <a href="https://youtu.be/0P7nCmln7PM" target="_blank" rel="noopener noreferrer">Learn how to create a minimally viable product</a> </li> 
                        <li> Step 2: Create consumer surveys for feedback. Tools:<a href="https://docs.google.com/forms" target="_blank" rel="noopener noreferrer"> Google Forms </a> or <a href="https://www.surveymonkey.com/user/sign-up/?ut_source=pricing_page" target="_blank" rel="noopener noreferrer">Survey Monkey </a> </li>
                        <li> Step 3: Analyze Your Data and refine your {{data?.offerType?.name}} </li>
                      </p>
                    </ng-container>
                    <ng-template #mvpService>
                      <p>
                        The best way to determine Product Market Fit, as mentioned above, is to ask your customer directly through primary market research.
                        Below are some resources that you can access to create and execute Product Market Fit research:
                         <li>Secondary Market Reserach: You can use <a href="https://ads.google.com/home/tools/keyword-planner/" target="_blank" rel="noopener noreferrer">Google’s Keyword Planner</a> and <a href="https://moz.com/explorer" target="_blank" rel="noopener noreferrer">Moz’s Keyword Explorer</a> to see how many potential customers are searching for services in your area. </li> 
                         <li>Primary Market Research: Ask some potential customers for feedback on your service idea. Create consumer surveys for feedback. Tools:<a href="https://docs.google.com/forms" target="_blank" rel="noopener noreferrer"> Google Forms </a> or <a href="https://www.surveymonkey.com/user/sign-up/?ut_source=pricing_page" target="_blank" rel="noopener noreferrer">Survey Monkey </a> </li>
                         <li>Put it into action: Analyze Your Data and refine your {{data?.offerType?.name}} </li>
                     </p>
                  </ng-template>
                    </div>
                    <!--ng template-->   
                        </div>
                      </mat-card-content>
                     <!-- <mat-card-footer class="p-2">
                        <mat-form-field appearance="fill">
                          <mat-label>Set Goal</mat-label>
                          <mat-select [(ngModel)]="probSolvStat" name="statResponse">
                            <mat-option *ngFor="let statResponse of statResp" [value]="statResponse?.value">
                              {{statResponse.viewValue}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                       <p> Selected Answer: {{probSolvStat}} </p>
                      </mat-card-footer>-->
                    </mat-card>
                </div> 
                <div class="col-lg-4 col-md-4 col-sm-12">
                  <mat-card>
                    <div class="pt-3"></div>
                   <!-- <mat-card-header class="d-flex justify-content-between">
                      <mat-card-title class="scoreText">{{assessmentPayload?.teamExecutionScore?.finalTeamExecutionPercentage*100 | number:'1.0-0'}}%</mat-card-title>
                      <mat-card-subtitle class="pt-3">{{assessmentPayload?.teamExecutionScore?.status}}</mat-card-subtitle>
                   <div align="end">
                    <div *ngIf="finalTeamExecutionPercentage < 0.53">
                      <mat-icon  class="red">thumb_down_alt</mat-icon>
                    </div>
                    <div *ngIf="finalTeamExecutionPercentage > 0.53">
                      <mat-icon class="teal">thumb_up_alt</mat-icon>
                    </div>
                   </div>
                    </mat-card-header>-->
                    <mat-card-content>
                        <h2 class="title">Market Barriers Status</h2>
                        <div>
                          <!-- <div *ngIf="teamOvercomeScore <= 3">-->
                          <p>Out of the below selected market barriers, the team has overcome
                            {{assessmentPayload?.teamUnadvCheckBoxCount}} out of {{assessmentPayload?.offerMarkEntryCheckBoxCount}}.
                          </p>
                          <p>
                          <b> Market Barriers:</b> {{assessmentPayload?.markBarArray}}
                          <br> <b>Barriers Overcome:</b> {{assessmentPayload?.teamUnadvNameArray?.teamUnadvNameArray}}
                          <br> <em>Develop strategies to overcome remaining market barriers or any potential threats that may arise</em>. 
                         </p>
                        </div>
                    </mat-card-content>
                    <!--<mat-card-footer class="p-2">
                      <mat-form-field appearance="fill">
                        <mat-label>Set Goal</mat-label>
                        <mat-select [(ngModel)]="offDifferentiationStat" name="offDiffStat">
                          <mat-option *ngFor="let offDiffStat of statResp" [value]="offDiffStat?.value">
                            {{offDiffStat.viewValue}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <p> Selected Answer: {{offDifferentiationStat}} </p>
                    </mat-card-footer>-->
                  </mat-card>
                 </div>    
              </div>
              <div class="pt-5"></div>
              <!--end row-->
            </mat-tab>
            <!--end product tab-->
        <!--Start Team Tab-->
      ;  <mat-tab  label="Team">
          <div class="pt-5"></div>
           <div class="row">
             <div class="col-4"> 
                <mat-card class="">
                  <div class="pt-3"></div>
                  <mat-card-header class="d-flex justify-content-between">
                    <mat-card-title class="scoreText">
                     {{assessmentPayload?.teamOverall?.finalTeamOverallAverage*100 | number:'1.0-0'}}%
                    </mat-card-title>
      
                    <mat-card-subtitle class="pt-3">
                      <button mat-button color="primary">  {{assessmentPayload?.teamOverall?.status}}</button>
                    </mat-card-subtitle>
                    <div  *ngIf="finalTeamOverallAverage < 0.53">
                      <mat-icon class="red">thumb_down_alt</mat-icon>
                    </div>
                    <div  *ngIf="finalTeamOverallAverage > 0.53">
                      <mat-icon class="teal">thumb_up_alt</mat-icon>
                    </div>
                  </mat-card-header>
                  <mat-card-content>
                    <div [ngClass]="{'lmtTxtHeight': isReadMore}">
                      <h4>Overall Team Dynamic Score</h4>
                       <p>
                        These results are not to discourage business ventures, but rather inform business models and possibilities for risks or improvements. 
                        <li>Please remember, scores, results and recommendations are informational.</li>
                        <li>These results are not meant to replace the human touch and we encourage you to seek counsel where needed. </li>
                        <li> Please provide feedback upon reviewing your results to help improve your user experience. </li>
                      </p>
                    </div>
                    <div class="pt-2"></div>
                    <button mat-flat-button color="primary" (click)="showTxt()">
                      {{isReadMore ? 'Read More' : 'Read Less'}}
                    </button>
                  </mat-card-content>
                </mat-card>  
          
             </div>
      
             <div class="col-8">
              <h2>Team Dynamic Summary</h2>
              <p>When investors choose to invest, many invest in the team versus the idea because people build
                businesses. Ideas may change throughout a business' lifetime, but it is likely that a well-established team will retain
                the ability to execute.  If the team is not able to get along, be productive and/or execute on the idea, the venture may fail.
                Therefore, team dynamic is important. The following Team Dynamics and scoring and recommendations are below.</p>
           <!--   <h2>Goal Status </h2>
           <div class="progress">
              <div class="progress-bar" role="progressbar" style="width: 25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div>
            </div>-->
      
            </div>
           </div>
           <!--end row-->
           <!--row-->
           <div class="pt-5"></div>
           <div class="row">
             <div class="col-lg-4 col-md-4 col-sm-12">
                  <mat-card>
                    <mat-card-header>
                        <mat-card-title> Sub Section Scores</mat-card-title>
                        <!--  <mat-card-subtitle>All Assesments Taken</mat-card-subtitle>-->
                    </mat-card-header>
                        <mat-card-content>
                          <ul class="list-group list-group-flush">
                            <li class="list-group-item d-flex justify-content-between align-items-center purple-txt">
                              Technical Skills
                              <h2 ><span class="badge">{{assessmentPayload?.teamTechnicalScore.status}}</span></h2>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center blue-txt">
                             Execution Ability
                             <h2 ><span class="badge">{{assessmentPayload?.teamExecutionScore.status}}</span></h2>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center teal">
                             Personality Dynamics
                             <h2 ><span class="badge">{{assessmentPayload?.teamPersonalityScore.status}}</span></h2>
                            </li>
                          </ul>
                     
                            <div class="pt-3"></div>
                            </mat-card-content>
                  </mat-card>
             </div>
          
            <div class="col-lg-8 col-md-8 col-sm-12">
                <mat-card>
                  <div class="pt-3"></div>
                  <mat-card-header class="d-flex justify-content-between">
                    <mat-card-title class="scoreText">{{assessmentPayload?.teamTechnicalScore?.finalTeamTechnicalPercentage*100 | number:'1.0-0'}}%</mat-card-title>
                    <mat-card-subtitle class="pt-3">{{assessmentPayload?.teamTechnicalScore?.status}}</mat-card-subtitle>
                 <div align="end">
                  <div *ngIf="finalTeamTechnicalPercentage < 0.53">
                    <mat-icon  class="red">thumb_down_alt</mat-icon>
                  </div>
                  <div *ngIf="finalTeamTechnicalPercentage > 0.53">
                    <mat-icon class="teal">thumb_up_alt</mat-icon>
                  </div>
                 </div>
                  </mat-card-header>
                
                  <mat-card-content>
                    <h2 class="title">What is the Team's Technical Capability?</h2>
                      <div>
                        <div *ngIf="assessmentPayload?.teamRoleCheckBoxCount">
                          <p>The team has a team of {{data?.teamMembersQuan}} who have expertise in {{assessmentPayload?.teamRoleNameArray?.teamRoleNameArray}}, out of 6 possible options: 
                            Administration and operations, Research and development, Technical Assistance (Trades), Production, Sales and marketing, and Accounting and finance.
                            These roles can be essential to build a successful business. <b>It may be helpful to enlist these roles as
                            additional members where needed, as capacity thins or opportunities expand</b>:
                            <li> Adding someone to the team with expertise in Administration and Operations and Production can help
                              with making processes and operations more efficient.</li>
                            <li> Adding someone to the team who has Research and Development skills or additional background
                              industry knowledge can help {{data?.busiName}} stay ahead of its competitors and innovate solutions.</li>
                            <li> Adding someone to the team that has technical assistance expertise, such as Sales and Marketing, or
                              Accounting and Finance (or contracting them) can help the team members with industry knowledge spend
                              time performing the service versus technicalities.</li>
                          </p>
                        </div>
                        <div *ngIf="data?.teamMembersQuan  < 2">
                          <p>If {{data?.busiName}} isn't in a place to hire, it can <b>expand capacity 
                            through interns and independent contractors</b>. Many colleges allow you to post listings on platforms 
                            such as <a href="https://app.joinhandshake.com/" target="_blank" rel="noopener noreferrer">Handshake</a>. To read about intern laws, 
                            read this one pager on the <a href="https://www.dol.gov/sites/dolgov/files/WHD/legacy/files/whdfs71.pdf" target="_blank" rel="noopener noreferrer">
                            Fair Labor Standards Act. </a> 
                          </p>
                        </div>
                      </div>
                      <div>
                        <div *ngIf="data?.teamIndustryKnowledge?.value  >= 3; else teamIndustryKnowledgeElse">
                          <p>The team knows the {{data?.offerIndustry?.name}} industry on a '{{data?.teamIndustryKnowledge?.name}}' level. This is good! <b>To
                            stay competitive, continue to learn, take courses and/or obtain further
                            certifications</b>. <a href="https://www.edx.org/" target="_blank" rel="noopener noreferrer">edX</a> and <a href="https://www.coursera.org/" target="_blank" rel="noopener noreferrer">Coursera</a> offer free online classess in some areas. 
                        </p>
                      </div>
                        <ng-template #teamIndustryKnowledgeElse>
                          <p>The team knows the {{data?.offerIndustry?.name}} industry on a '{{data?.teamIndustryKnowledge?.name}}' level. 
                            <b>Add a team member with greater knowledge in order to gain a competitive advantages against
                            competition.</b>
                          </p>
                        </ng-template>
                      </div>
                      <div>
                        <div *ngIf="data?.teamTime?.value <= 4; else teamTimeElse">
                          <p>The amount of time that the average team member 
                            has to devote is {{data?.teamTime?.name}}, with a total of {{data?.teamMembersQuan}} team member(s). 
                            It can make a productive difference if at least one team member decides to work full-time.</p>
                        </div>
                        <ng-template #teamTimeElse>
                          <p>The amount of time that the average team member 
                            has to devote is {{teamTime?.name}}, with a total of {{data?.teamMembersQuan}} team member(s).
                           This is good, and can help the team achieve it’s goals much faster than not. <b>Enlist processes 
                           to scale the team, such as operations manuals, here are 
                           <a href="https://www.sampletemplates.com/business-templates/operation-manual.html" target="_blank" rel="noopener noreferrer"> 7 Free Operations Templates. </a>
                           And implement or review HR practices</b>. 
                          </p>
                        </ng-template>
                      </div>
                  </mat-card-content>
                  <!--<mat-card-footer class="p-2">
                    <mat-form-field appearance="fill">
                      <mat-label>Set Goal</mat-label>
                      <mat-select [(ngModel)]="probSolvStat" name="statResponse">
                        <mat-option *ngFor="let statResponse of statResp" [value]="statResponse?.value">
                          {{statResponse.viewValue}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                   <p> Selected Answer: {{probSolvStat}} </p>
                  </mat-card-footer>-->
                </mat-card>
            </div>  
                 
          </div>
          <div class="pt-5"></div>
          <!--end row-->
          <div class="row">
            <!--How product or service different-->
             <div class="col">
              <mat-card>
                <div class="pt-3"></div>
                <mat-card-header class="d-flex justify-content-between">
                  <mat-card-title class="scoreText">{{assessmentPayload?.teamExecutionScore?.finalTeamExecutionPercentage*100 | number:'1.0-0'}}%</mat-card-title>
                  <mat-card-subtitle class="pt-3">{{assessmentPayload?.teamExecutionScore?.status}}</mat-card-subtitle>
               <div align="end">
                <div *ngIf="finalTeamExecutionPercentage < 0.53">
                  <mat-icon  class="red">thumb_down_alt</mat-icon>
                </div>
                <div *ngIf="finalTeamExecutionPercentage > 0.53">
                  <mat-icon class="teal">thumb_up_alt</mat-icon>
                </div>
               </div>
                </mat-card-header>
              
                <mat-card-content>
                    <h2 class="title">What is the Execution Ability of the Team?</h2>
                    <div>
                      <div *ngIf="data?.teamNetwork?.value  <= 3; else teamNetworkElse">
                        <p>Your ability to attract customers and/or develop {{data?.busiName}} through your current
                          network was rated as '{{data?.teamNetwork?.name}}. <b>Expand your network by
                           attending networking events, using <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a>, asking your existing network for introductions, etc. </b></p>
                      </div>
                      <ng-template #teamNetworkElse>
                        <p>Your ability to attract customers and/or develop {{data?.busiName}} through your current
                          network was rated as '{{data?.teamNetwork?.name}}. This is a strength, saving you time,
                          energy, and providing a competitive advantage.  <b>Reach out to your network to continue to build connections
                          and grow</b>. Here are <a href="https://www.themuse.com/advice/4-email-templates-to-make-networking-way-less-awkward" target="_blank" rel="noopener noreferrer">4 Networking Email Templates</a> to get started. 
                        </p>
                      </ng-template>
                    </div>
                    <div>
                      <div *ngIf="data?.teamTimeManage?.value <= 3; else teamTimeManageElse">
                        <br>
                        <p>The team’s ability to set, prioritize, track and meet goals when given a timeline was rated as
                      '{{data?.teamTimeManage?.name}}'. <b>Check out the <a
                            href="https://youtu.be/1-SvuFIQjK8" target="_blank">SMART Goal Setting method</a> to improve this</b>. Here is a <a
                            href="https://www.smartsheet.com/file/smart-goals-template.docx" target="_blank">downloadable SMART
                            Goals Template</a>. In addition, tools such as Sustainible, <a href="https://asana.com/" target="_blank">Asana</a> or <a
                            href="https://trello.com/en-US" target="_blank">Trello</a>, can help prioritize, track and manage
                          these goals and action plans. Some of these tools have free versions.
                        </p>
                      </div>
                      <ng-template #teamTimeManageElse>
                        <p> The team’s ability to set, prioritize, track and meet goals when given a timeline was rated as '{{data?.teamTimeManage?.name}}'.
                          Great job! <b>Automate the process</b>: <a href="https://asana.com/" target="_blank">Asana</a> and 
                          <a href="https://trello.com/en-US" target="_blank">Trello</a> are online team management tools that have free versions.
                        </p>
                      </ng-template>
                    </div>
                    <div>
                      <div *ngIf="data?.teamAccountability?.value <= 3; else teamAccountabilityElse">
                        <p>Team members are '{{data?.teamAccountability?.name}}' to the team and its progress.
                          Accountability can foster reliability, confidence and trust between team members, for greater success in
                          meeting goals and maintaining the business.
                         <b> Work on fostering team accountability</b>, here are some <a
                            href="https://bizfluent.com/info-7826390-accountability-team-building-exercises.html"
                            target="_blank">Team Building Exercises.</a></p>
                      </div>
                      <ng-template #teamAccountabilityElse>
                        <p>Team members are '{{data?.teamAccountability?.name}}' to the team and its progress. Great job!
                          Accountability can foster reliability, confidence and trust between team members, for greater success in
                          meeting goals and maintaining the business. <b>Some ideas to reward the team for efforts</b> are gift cards, 
                          team lunches and a simple 'Thank You'. 
                        </p>
                      </ng-template>
                    </div>
                    <div>
                      <div *ngIf="data?.teamUnproductivity?.value >= 4; else teamUnproductivityElse">
                        <p>The team {{data?.teamUnproductivity?.name}} encounters disfunctionality. This is good - team
                          dysfunctionality can make or break a business. </p>
                      </div>
                      <ng-template #teamUnproductivityElse>
                        <p> The team {{data?.teamUnproductivity?.name}} encounters disfunctionality.
                          Team dysfunctionality can make or break a business.
                          This article by Medium addresses common problems and suggests <a
                            href="https://medium.com/taskworld-blog/lencionis-5-dysfunctions-of-a-team-330d58b2cd81"
                            target="_blank"> solutions to overcome team dysfunction.</a></p>
                      </ng-template>
                    </div>
                </mat-card-content>
              <!--  <mat-card-footer class="p-2">
                  <mat-form-field appearance="fill">
                    <mat-label>Set Goal</mat-label>
                    <mat-select [(ngModel)]="teamExecutionStat" name="teamExStat">
                      <mat-option *ngFor="let teamExStat of statResp" [value]="teamExStat?.value">
                        {{teamExStat.viewValue}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </mat-card-footer>-->
              </mat-card>
             </div>
             <div class="col">
              <mat-card>
                <div class="pt-3"></div>
                <mat-card-header class="d-flex justify-content-between">
                  <mat-card-title class="scoreText">{{assessmentPayload?.teamPersonalityScore?.finalTeamPersonalityPercentage*100 | number:'1.0-0'}}%</mat-card-title>
                  <mat-card-subtitle class="pt-3">{{assessmentPayload?.teamPersonalityScore?.status}}</mat-card-subtitle>
               <div align="end">
                <div *ngIf="finalTeamPersonalityPercentage < 0.53">
                  <mat-icon  class="red">thumb_down_alt</mat-icon>
                </div>
                <div *ngIf="finalTeamPersonalityPercentage > 0.53">
                  <mat-icon class="teal">thumb_up_alt</mat-icon>
                </div>
               </div>
                </mat-card-header>
              
             <mat-card-content>
                <h2 class="title">What is the Team Disposition?</h2>
                <div>
                  <div *ngIf="data?.teamLeaderSerialEntrp?.name === 'Yes'; else teamLeaderSerialEntrpElse">
                    <p>  It's great the core team has business management experience! 
                    </p>
                  </div>
                  <ng-template #teamLeaderSerialEntrpElse>
                    <p>If no one on the team has entrepreneurial experience, that's no problem! 
                      It could help to <b>find someone who has entrepreneurial experience, such as a mentor in your industry</b>, 
                      incubators, development centers or business consultants. They can advise 
                      the leader and company on hurdles as an entrepreneur. {{retrieveRecommandationText('teamLeaderSerialEntrp')}}
                    </p>
                  </ng-template>
                </div>
                <div>
                  <div *ngIf=" data?.teamExistingCustomerBase?.name === 'Yes'; else teamExistingCustomerBaseElse">
                    <p>  It's great that you already have customers! <b>Establish ways to reach new customers</b>.
                      Refferal discounts,  social media contests and loyalty programs can be beneficial. 
                      Marketing messages such as “if you like our first {{data?.offerType?.name}}, then you’ll love our 
                      second” may intrigue customers to buy.
                    </p>
                  </div>
                  <ng-template #teamExistingCustomerBaseElse>
                    <p>Once a rapport of being an established and trusted company is built, 
                      customers may be more likely to become recurring customers and create referrals. 
                     <b> Having a solid brand can help build trust and credibility.</b> 
                      {{retrieveRecommandationText('teamExistingCustomerBase')}}
                     </p>
                  </ng-template>
                </div>
              <div>
                  <div *ngIf="data?.teamPassion?.value  <= 3; else teamPassionElse">
                    <p>  The team is '{{data?.teamPassion?.name}}' about the business.
                      The entrepreneurial journey can come with road bumps, passion is 
                      something to depend on. <b>Give it some thought, there may be ways to 
                      weave your passion into your business or vice versa</b>.
                    </p>
                  </div>
                  <ng-template #teamPassionElse>
                    <p>The team is '{{data?.teamPassion?.name}}' about the business. 
                      <b>Share your passion with your customer(s) to get them excited about your business too!</b> 
                      Some ideas are creating blogs, newsletters, content creation, speaking events, etc. 
                    </p>
                  </ng-template>
                </div>
                <div>
                  <div *ngIf="data?.teamRisk?.value <= 3; else teamRiskElse">
                    <p>The team’s ability to handle risk was rated
                      as '{{data?.teamRisk?.name}}'. Entrepreneurial journeys can involve some level of risk. 
                      <b>Understand how to minimize risk before the situation arises</b>. These recommendations are a first step! In addition, this brief step
                      by step article by Chron covers “<a href="https://smallbusiness.chron.com/overcome-fear-risktaking-business-22871.html"
                        target="_blank">How to Overcome the Fear of Risk-Taking in Business</a>”.
                      As for additional risk management strategies, <b> perform a  “<a
                        href="https://blog.hubspot.com/marketing/swot-analysis" target="_blank">SWOT analysis</a> (your personal starter is included the in Product-Market Fit tab)
                         or enlist risk management tools</b>.</p>
                  </div>
                  <ng-template #teamRiskElse>
                    <p> The team’s ability to handle risk was rated as
                      '{{data?.teamRisk?.name}}'. Great job managing risk, you can  <b>use the personalized SWOT in our Product Market Fit tab to help identify potential risks</b>. 
                    </p>
                  </ng-template>
              </div>
              <ng-container *ngIf="showQ15to17">
              <div>
                  <div *ngIf="data?.teamRecognition?.value <= 3; else teamRecognitionElse">
                    <p>Recognizing or rewarding team member contributions for progress or achievement can encourage lower
                      turnover rates, higher accountability, ownership and
                      overall organizational results.
                      Your team’s recognition was rated as '{{data?.teamRecognition?.name}}'.
                      Some ways to show recognition may be as simple as saying ‘thank you for your contribution’
                      during a team meeting. You can find ideas by simply searching for ‘Team Recognition Ideas’ on the web.
                    </p>
                  </div>
                  <ng-template #teamRecognitionElse>
                    <p>In many cases team recognition can lead to lower turnover rates, higher accountability, ownership and
                      overall organizational results.
                      The team’s recognition of member contributions was rated as '{{data?.teamRecognition?.name}}'.</p>
                  </ng-template>
                </div>
                <div>
                  <div *ngIf="data?.teamOpenness?.value <= 3; else teamOpennessElse">
                    <p>When building a business, it’s quite possible for mistakes or problems to happen.
                      The team’s ability to openly admit mistakes or problems was rated as '{{data?.teamOpenness?.name}}'.
                      How the team handles internal mistakes can often affect progress. This brief step by step article by Inc
                      covers
                      “<a href="https://www.inc.com/lolly-daskal/4-impressive-ways-great-leaders-handle-their-mistakes.html"
                        target="_blank">
                        4 Impressive Ways Great Leaders Handle Their Mistakes.</a>"</p>
                  </div>
                  <ng-template #teamOpennessElse>
                    <p>When building a business, it’s quite possible for mistakes or problems to happen; how the team handles
                      internal mistakes can often affect progress.
                      The team’s ability to openly admit mistakes or problems was rated as '{{data?.teamOpenness?.name}}'.
                    </p>
                  </ng-template>
                </div>
              <div>
                <div *ngIf="data?.teamTrust?.value <= 3; else teamTrustElse">
                  <p> The team’s confidence in each other’s ability to perform tasks was rated as
                    '{{data?.teamTrust?.name}}'. Frequent meetings are a good way to keep team members 
                    accountable and on track. Regularly checking on members’ progress during these 
                    meetings motivates them to be productive in order to have something to show for
                     their work.
                  </p>
                </div>
                <ng-template #teamTrustElse>
                  <p>Good job. The team’s confidence in each other’s ability to perform tasks was rated as
                    '{{data?.teamTrust?.name}}'. Great job! </p>
                </ng-template>
              </div>
            </ng-container>
                </mat-card-content>
               <!-- <mat-card-footer class="p-2">
                  <mat-form-field appearance="fill">
                    <mat-label>Set Goal</mat-label>
                    <mat-select [(ngModel)]="industryCondStat" name="industryCond">
                      <mat-option *ngFor="let industryCond of statResp" [value]="industryCond?.value">
                        {{industryCond.viewValue}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <p> Selected Answer: {{industryCondStat}} </p>
                </mat-card-footer>-->
              </mat-card>
            </div>
             
          </div>
          <!--end row-->
        </mat-tab>
        <!--End Team Tab-->
       
          </mat-tab-group>
        </article>
      </div>
    </div>
  </section>